import { useEffect, useRef, useState } from "react";

const useDisplayElementList = () => {
  const [openSheet, setOpenSheet] = useState(false);
  const [isElementListVisible, setIsElementListVisible] = useState(false);
  const elementListRef = useRef<HTMLDivElement>(null);

  const title = "Player Selection";
  const subtitle = (
    <>
      Select a maximum of 3 players from a single team or 'Auto Pick' if you're
      short of time.
    </>
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const elementListIsVisible = entry.isIntersecting;
        setIsElementListVisible(elementListIsVisible);
        if (elementListIsVisible) {
          handleCloseElementList();
        }
      },
      { threshold: 0.1 },
    );

    if (elementListRef.current) {
      observer.observe(elementListRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleOpenElementList = () => {
    if (isElementListVisible) return;
    setOpenSheet(true);
  };

  const handleCloseElementList = () => {
    setOpenSheet(false);
  };

  return {
    title,
    subtitle,
    handleOpenElementList,
    handleCloseElementList,
    elementListRef,
    openSheet,
    setOpenSheet,
  };
};

export default useDisplayElementList;
